<template>
	<div>
		<!-- 头部搜搜 -->
		<ul style="width: 100%;background-color: #FFFFFF;">
			<!-- 搜索组件 -->
			<newTpSearch :hotState='false'></newTpSearch>
		</ul>
		
		<!-- 中心盒子 -->
		<div class="ctnBigConBox">
			<!-- 标题 -->
			<div class="ctnTopBox d-rn d-aic d-jcb">
				<!-- 左 -->
				<ul class="ctnTopBox-lftBox d-rn d-aic d-jcc">
					全部宝贝
				</ul>
				<!-- 右===删除模块 -->
				<ul class="ctnTopBox-rgtBox d-rn d-aic d-jce">
					<!-- 全选模块 -->
					<li class="ctnTopBox-rgtBox-allModel d-rn d-aic d-jcs showHand" 
					v-show="isEditState?true:false" @click="handleSelAllBtn()">
						<img class="" :src="!isAllSelectState?require('../../assets/img/comm/selectAll.png'):
						require('../../assets/img/comm/selectedAll.png')" >
						<p>全选</p>
					</li>
					<!-- 删除按钮 -->
					<li class="ctnTopBox-rgtBox-delBtn d-rn d-aic d-jcs showHand"
					 @click="handleDelBtn()" v-show="isEditState?true:false">
						<img src="../../assets/img/comm/delete.png" >
						<p>删除</p>
					</li>
					<!-- 操作按钮 -->
					<li class="ctnTopBox-rgtBox-handBtn noSelectBox showHand" @click="handleJoinEdit">
						{{isEditState?'取消管理':'批量管理'}}
					</li>
				</ul>
			</div>
			
			<!-- 有数据 -->
			<div class="shopHasData d-rw d-aic d-jcs noSelectBox">
				<!-- 每个商品 -->
				<ul v-for="(item,index) in shopCollectArr" :key='index'
				:class="['shopHasData-itemshop',(index+1)%5==0?'':'ctnMarRgt30']"
				@click="handleClickItemShop(item,index)"
				@mouseenter="handleJoinItemShop(index)" @mouseleave="suspensionIndex=null">
					<!-- 商品图片 -->
					<div class="shopHasData-topShopImg">
						<!-- 商品图片 -->
						<img :src="item.goods_img" class="shopHasData-topShopImg-shopImg" >
						
						<!-- 删除图片===悬浮下标等于当前下标且非编辑状态 -->
						<img src="../../assets/img/comm/c_delete.png" class="shopHasData-topShopImg-shopDelImg showHand"
						@click.stop="handleDelCurrentShop(item,index)"
						 v-show="suspensionIndex >=0 && suspensionIndex==index && !isEditState && delCurrentShop!=index?true:false">
						<!-- 商品文字提示===悬浮下标等于当前下标且非编辑状态 -->
						<p v-show="suspensionIndex >=0 && suspensionIndex==index && !isEditState && delCurrentShop!=index?true:false"
						class="shopHasData-topShopImg-shopTipsTxt boxNoYs one-txt-cut">
							{{item.goods_title}}
						</p>
						
						<!-- 编辑状态 -->
						<p v-show="isEditState?true:false"
						class="shopHasData-topShopImg-editSelBox d-rn d-ais d-jce">
							<img v-if="editSelShopIndexArr.indexOf(index)>=0" src="../../assets/img/comm/icon_batchall.png" >
							<img v-else src="../../assets/img/comm/icon_batch.png" >
						</p>
					</div>
					<!-- 商品信息 -->
					<li class="shopHasData-btmShopInfo d-cw d-aic d-jcc">
						<p class="showHand txt-cuts">{{item.goods_title}}</p>
						<p class="showHand">￥{{item.goods_money?item.goods_money.toFixed(2):''}}</p>
					</li>
					
					<!-- 删除当前模块提示 -->
					<li v-show="delCurrentShop>=0 && delCurrentShop==index && !isEditState?true:false"
					class="shopHasData-delShopTips d-cw d-aic d-jcc">
						<p>确定删除？</p>
						<p class=" d-rn d-aic d-jcc">
							<span class="showHand" @click.stop="handleClickDelTipsBtn(ix)" 
							v-for="(it,ix) in 2" :key='ix'>
								{{!ix?'确定':'取消'}}
							</span>
						</p>
					</li>
				</ul>
				
				
			</div>
			<!-- 无数据处理 -->
			<ul class="shopNoData d-cw d-aic d-jcc" v-if="shopCollectArr && !shopCollectArr.length">
				<img src="../../assets/img/privacy/noCollection.png" >
				<p>暂无收藏</p>
			</ul>
		</div>
		
		<!-- 弹窗提示 -->
		<div class="allDelTipsBox d-cw d-aic d-jcc noSelectBox" v-show="editAllDelTips?true:false">
			<!-- 定位图片 -->
			<img src="../../assets/img/comm/icon_cha.png"
			 class="allDelTipsBox-rgtDelImg showHand" @click="handleClickAllShopTips(1)">
			<!-- 提示内容 -->
			<p class="allDelTipsBox-conTxtTips">确定删除？</p>
			<!-- 按钮 -->
			<p class="allDelTipsBox-btmBtnBox d-rn d-aic d-jcc">
				<span class="showHand" v-for="(item,index) in 2" :key='index'
				@click="handleClickAllShopTips(index)">
					{{!index?'确定':'取消'}}
				</span>
			</p>
		</div>
	</div>
</template>

<script>
	import newTpSearch from '../../components/newTpSearch.vue'
	import { selByList,delAppCCollect } from '@/api/collection.js'
	import { fileUpload,appCUserFindById } from '@/api/comm.js'
	import tSearch from "@/components/tSearch.vue"
	let _self;
	export default {
		name:"Collection",
		components: {
			// 引入搜索组件
			tSearch,
			newTpSearch
		},
		data() {
			return {
				// 编辑状态===true编辑状态
				isEditState:false,
				// 编辑状态下===选中的商品下标数组
				editSelShopIndexArr:[],
				// 编辑状态下===删除提示框显示状态，true显示
				editAllDelTips:false,
				// 是否全选===true全选
				isAllSelectState:false,
				// 页面配置
				pageInfo:{
					page:1,
					size:8
				},
				// 是有允许请求下一页==true有下一页
				collectionIsNext:false,
				// 商品数据
				shopCollectArr:null,
				// 定义鼠标悬浮商品下标
				suspensionIndex:null,
				// 删除当前商品==提示是否确定删除弹窗
				delCurrentShop:null,
				
				
				// 点击事件请求状态
				isRequestState:false,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log("用户信息",_self.userInfo);
			if(_self.userInfo){
				// 有用户信息
				_self.handleUpdateUserInfo();
			}
			
			this.$EventBus.$emit('AppCloseNav', true);
			// 查询我的收藏列表
			_self.getCollectionList();
		},
		methods: {
			// 更新用户信息
			handleUpdateUserInfo(){
				appCUserFindById({
					userId:_self.userInfo.userId
				}).then(tes=>{
					if(tes.code==200){
						// 接口获取成功
						//定义本地存储的userInfo
						localStorage.setItem('userInfo',JSON.stringify(tes.data))
						// 传递给topBar==用户信息
						_self.$EventBus.$emit('userEditInfo',tes.data)
						// 定义当前用户信息
						_self.$set(_self,'userInfo',tes.data)
					}
				})
			},
			//查询列表接口
			getCollectionList(){
				
				selByList({
					..._self.pageInfo,
					collectUserId:_self.userInfo.userId
				}).then(res=>{
					if(res.code==200){
						// 判断有无数据
						if(res.data.list && res.data.list.length ){
							// 有数据
							
							// 判断页数
							if(_self.pageInfo.page==1){
								_self.shopCollectArr=res.data.list;
							}else{
								_self.shopCollectArr=[..._self.collectionArr,...res.data.list];
							}
						}else if(_self.pageInfo.page==1){
							// 没有数据，请求第一页====定义空数组
							_self.shopCollectArr=[];
						}
						// console.log('商品信息===',_self.shopCollectArr);
						// 判断是否有下一页可以请求
						_self.collectionIsNext=res.data.hasNextPage;
					}
				})
			},
			
			
			// 打开/取消===编辑状态
			handleJoinEdit(){
				// 修改编辑状态
				_self.isEditState=!_self.isEditState;
				//定义全选状态
				_self.isAllSelectState=false;
				// 定义选中的数组下标为空
				_self.editSelShopIndexArr=[];
				// 清楚==删除耽搁商品提示框
				_self.delCurrentShop=null;
			},
			// 全选按钮
			handleSelAllBtn(){
				// 状态取反
				_self.isAllSelectState=!_self.isAllSelectState;
				if(_self.isAllSelectState){
					// 全选
					
					// 定义选中的数组
					let selArr=[];
					// 增添下标
					_self.shopCollectArr.forEach((item,index)=>{
						selArr.push(index);
					})
					// 定义选中的数组
					_self.$set(_self,'editSelShopIndexArr',selArr);
				}else{
					// 非全选
					_self.$set(_self,'editSelShopIndexArr',[]);
				}
			},
			// 编辑状态===删除按钮==》打开全局提示
			handleDelBtn(){
				// 判断是否选中了商品
				if(_self.editSelShopIndexArr && !_self.editSelShopIndexArr.length){
					// 提示==
					_self.$jgTips('请选择要删除的商品！');
					return false;
				}
				// 打开提示弹窗
				_self.editAllDelTips=true;
			},
			// 编辑状态下===提示框点击事件
			handleClickAllShopTips(val){
				if(val==0){
					// 确定===删除选中的
					// console.log('查看要删除的下标',_self.editSelShopIndexArr);
					// 定义传给后台的数据
					let requestData=[];
					// 定义删除选中的商品后的新商品列表
					let delAfterShopList=[];
					// 深层转义商品列表数据
					let newShopData=JSON.parse(JSON.stringify(_self.shopCollectArr));
					// 循环获取删除下标
					newShopData.forEach((it,ix)=>{
						if(_self.editSelShopIndexArr.indexOf(ix)>=0){
							// console.log('要删除当前商品===',it);
							requestData.push(it.collect_id);
						}else{
							delAfterShopList.push(it);
						}
					})
					// 判断请求状态
					if(_self.isRequestState){
						_self.$jgTips('数据正在请求中，请稍等');
						return false;
					};
					_self.isRequestState=true;
					// 接口请求
					delAppCCollect({
						collectId:requestData
					}).then(res=>{
						// console.log('批量删除接口====',res);
						if(res.code==200){
							// 取消所有选中的商品
							_self.$set(_self,'editSelShopIndexArr',[]);
							// 关闭弹窗
							_self.editAllDelTips=false;
							// 提示删除成功
							_self.$message({
								message:'删除成功',
								type:'success'
							});
							// 定义新显示数组
							_self.$set(_self,'shopCollectArr',delAfterShopList);
							
						}
						// 允许再次请求
						_self.isRequestState=false;
					})
					
					
				}else{
					// 关闭弹窗
					_self.editAllDelTips=false;
					
					// 取消所有选中的商品
					_self.$set(_self,'editSelShopIndexArr',[]);
				}
			},
			/* 
				点击商品整体
				编辑状态===》选中当前商品
				非编辑状态===》跳转商品详情
			 */
			handleClickItemShop(item,index) {
				if(this.isEditState){
					// 当前为编辑状态
					
					
					//判断选中数据是否在数组中
					if (_self.editSelShopIndexArr.indexOf(index) >= 0) {
						//如果是选中的话，再次点击时删除当前选中的值
						_self.editSelShopIndexArr.splice(_self.editSelShopIndexArr.indexOf(index), 1);
						//删除值之后就不是全选状态，改为false
						_self.isAllSelectState = false;
					} else {
						_self.editSelShopIndexArr.push(index);
						//判断选中的数组与列表的数组是否相等，true则为全选
						if (_self.editSelShopIndexArr.length == _self.shopCollectArr.length) {
							_self.isAllSelectState = true;
						}
					}
				}else{
					// 当前为非编辑状态===点击跳转到商品详情
					
					// 定义商品id
					// 编码encodeURIComponent() ||  解码decodeURIComponent()
					let pageVal=encodeURIComponent(JSON.stringify({shopId:item.tarder_goods_id}));
					// 跳转到搜索页面并传递搜索信息
					_self.$router.push({path:'/ShopDetails',query:{id:pageVal}})
				}
			},
			
			
			
			// 删除单个商品==》打开删除单个提示框
			handleDelCurrentShop(item,index){
				// 定义当前要删除商品的下标
				_self.delCurrentShop=index;
			},
			// 删除当前商品===弹框点击事件
			handleClickDelTipsBtn(val){
				if(val==0){
					// 确定删除
					// console.log('要删除的商品信息',_self.shopCollectArr[_self.delCurrentShop]);
					// console.log('要删除的商品信息===下标',_self.delCurrentShop);
					// 判断请求状态
					if(_self.isRequestState){
						_self.$jgTips('数据正在请求中，请稍等');
						return false;
					};
					_self.isRequestState=true;
					// 接口请求
					delAppCCollect({
						collectId:[_self.shopCollectArr[_self.delCurrentShop].collect_id]
					}).then(res=>{
						if(res.code==200){
							// 转义数组
							let newShopArr=JSON.parse(JSON.stringify(_self.shopCollectArr));
							newShopArr.splice(_self.delCurrentShop,1);
							
							// 关闭删除商品的提示框
							_self.delCurrentShop=null;
							
							// 提示删除成功
							_self.$message({
								message:'删除成功',
								type:'success'
							});
							// 删除当前商品
							_self.$set(_self,'shopCollectArr',newShopArr)
						}
						// 允许再次请求
						_self.isRequestState=false;
					})
				}else{
					// 取消
					_self.delCurrentShop=null;
				}
			},
			//鼠标悬停时===定义显示删除按钮和商品名称
			handleJoinItemShop(val) {
				_self.suspensionIndex= val;
			},
		},
		mounted() {
			// 定义页面背景色
			document.body.style.background='#FFFFFF';
			
			// 滚动到头部
			window.scrollTo({
			    left: 0,
			    top: 0,
			});
			// 监听页面滑动
			window.onscroll = function(){
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
				// 获取当前页面名称
				let pageName=_self.$router.history.current.name;
				
				
				// 向上取整  （像素）
				let maxHeight=Math.ceil(scrollTop+windowHeight);
				//滚动条到底部的条件：  滑动距离+滑块高度大于侧边滚动条长度***最新的滚动条长度不等于上回的高度***允许加载下一页
				if( pageName=='Collection' && maxHeight==scrollHeight
				&& _self.collectionIsNext){
					// 不允许请求下一页====防止频繁请求
					_self.collectionIsNext=false;
					
					// 请求页码数+1
					_self.pageInfo.page++;
					// 数据请求
					_self.getCollectionList();
				}
			}
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		}
	}
</script>

<style lang="scss">
	/* 中心盒子 */
	.ctnBigConBox{
		width: 1200px;
		background: #fff;
		min-height: 750px;
		margin: 20px auto 0;
	}
	/* 头部盒子 */
	.ctnTopBox{
		width: 100%;
		/* 左 */
		&-lftBox{
			padding: 10px 0;
			width: 140px;
			height: 40px;
			font-size: 22px;
			font-weight: 400;
			color: #e62129;
			
			border-bottom: 2px solid #E62129;
		}
		/* 右 */
		&-rgtBox{
			flex: 1;
			padding: 10px 0;
			border-bottom: 2px solid #ccc;
			/* 全选模块 */
			&-allModel{
				margin-right: 40px;
				img{
					width: 24px;
					height: 24px;
					margin-right: 5px;
				}
				p{
					font-size: 20px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
			}
			/* 删除按钮 */
			&-delBtn{
				margin-right: 40px;
				img{
					width: 24px;
					height: 24px;
					margin-right: 5px;
				}
				p{
					font-size: 20px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
			}
			/* 操作按钮 */
			&-handBtn{
				width: 128px;
				height: 40px;
				opacity: 1;
				background: #ffffff;
				border: 1px solid #cccccc;
				box-sizing: border-box;
				margin-right: 30px;
				
				font-size: 22px;
				font-weight: 400;
				line-height: 40px;
				text-align: center;
				color: #999999;
			}
		}
		
	}
	/* 无数据 */
	.shopNoData{
		width: 100%;
		padding: 105px 0 150px;
		img{
			width: 352px;
			height: 352px;
			margin-bottom: 15px;
		}
		p{
			font-size: 18px;
			font-weight: 400;
			text-align: center;
			color: #666666;
			letter-spacing: 1px;
		}
	}
	/* 有数据 */
	.shopHasData{
		width: 100%;
		padding-top: 10px;
		/* 每个商品 */
		&-itemshop{
			width: 216px;
			height: 323px;
			margin-top: 30px;
			position: relative;
		}
		/* 上部分=商品图片 */
		&-topShopImg{
			width: 100%;
			height: 216px;
			position: relative;
			/* 商品图片 */
			&-shopImg{
				width: 100%;
				height: 100%;
				z-index: 2;
			}
			
			/* 删除图片 */
			&-shopDelImg{
				width: 36px;
				height: 36px;
				position: absolute;
				top: 0;
				right: 0;
				z-index: 5;
			}
			/* 提示文字 */
			&-shopTipsTxt{
				padding: 9px;
				box-sizing: border-box;
				background: #ffffff;
				border: 1px solid #999999;
				box-sizing: border-box;
				z-index: 5;
				max-width: 1200px;
				white-space: nowrap;
				font-size: 20px;
				font-weight: 400;
				color: #666666;
				letter-spacing: 2px;
				
				position: absolute;
				top: 118px;
				left: 118px;
			}
			
			/* 编辑状态下==选择样式 */
			&-editSelBox{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0,0,0,0.4);
				img{
					width: 60px;
					height: 60px;
				}
			}
		}
		/* 下部分=商品价格/名称 */
		&-btmShopInfo{
			width: 100%;
			padding: 15px 6px;
			box-sizing: border-box;
			p{
				width: 100%;
			}
			p:nth-of-type(1){
				font-size: 20px;
				font-weight: 400;
				color: #666666;
				text-align: center;
				letter-spacing: 2px;
			}
			p:nth-of-type(2){
				font-size: 20px;
				font-weight: 400;
				text-align: center;
				color: #e62129;
				letter-spacing: 2px;
				margin-top: 10px;
			}
		}
		/* 删除提示模块 */
		&-delShopTips{
			position: absolute;
			z-index: 6;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0,0,0,0.45);
			p:nth-of-type(1){
				font-size: 20px;
				font-weight: 400;
				text-align: center;
				color: #ffffff;
				letter-spacing: 2px;
			}
			p:nth-of-type(2){
				margin-top: 20px;
				width: 100%;
				span{
					display: inline-block;
					
					width: 72px;
					height: 30px;
					text-align: center;
					line-height: 30px;
					font-size: 14px;
					font-weight: 400;
					letter-spacing: 1px;
				}
				span:nth-of-type(1){
					background: #e62129;
					margin-right: 10px;
					color: #ffffff;
				}
				span:nth-of-type(2){
					background: #ffffff;
					color: #666666;
				}
			}
		}
	}
	.ctnMarRgt30{
		margin-right: 30px;
	}
	/* 编辑状态===删除提示 */
	.allDelTipsBox{
		width: 424px;
		height: 296px;
		opacity: 1;
		background: #ffffff;
		border: 1px solid #999999;
		box-sizing: border-box;
		position: fixed;
		z-index: 30;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		/* 删除图片 */
		&-rgtDelImg{
			position: absolute;
			width: 20px;
			height: 20px;
			top: 30px;
			right: 30px;
		}
		/* 提示文字 */
		&-conTxtTips{
			width: 100%;
			font-size: 20px;
			font-weight: 400;
			text-align: center;
			color: #999999;
			letter-spacing: 2px;
		}
		/* 底部按钮 */
		&-btmBtnBox{
			width: 100%;
			margin-top: 40px;
			span{
				display: inline-block;
				width: 72px;
				height: 30px;
				text-align: center;
				line-height: 30px;
				
				font-size: 14px;
				font-weight: 400;
				letter-spacing: 1px;
			}
			span:nth-of-type(1){
				background: #e62129;
				color: #ffffff;
				margin-right: 40px;
			}
			span:nth-of-type(2){
				background: #f1f1f1;
				color: #666666;
			}
		}
		
	}
</style>
